import * as React from 'react';
import { createElement, cloneElement } from 'react';
import { Form, ResponsiveGrid, Button } from '@alifd/next';
const CbayelForm = (props, ref) => {
    const { children, columns, spacing = [0, 16, 16, 0], emptyContent, status, operations = [], ...otherProps } = props;
    const isPreview = status === 'readonly';
    return (createElement(Form, { ...otherProps, ref: ref, isPreview: isPreview },
        createElement(ResponsiveGrid, { gap: spacing, columns: columns }, children ? (formatFormItems(children, { ...otherProps, isPreview })) : (createElement("div", { className: "empty-content" }, emptyContent))),
        isPreview ? null : (createElement("div", { style: { textAlign: 'center' } },
            createElement(Button.Group, null, operations.map(({ id, content, type, onClick }) => {
                return (createElement(Button, { key: id, onClick: onClick, type: type }, content));
            }))))));
};
const CbayelFormRef = React.forwardRef(CbayelForm);
export default CbayelFormRef;
export const formatFormItems = (children, props = {}) => {
    const { labelAlign, labelCol, wrapperCol, labelTextAlign, isPreview, colon, changingField, field, } = props;
    const _children = children.filter((child) => child && ['function', 'object'].indexOf(typeof child) > -1);
    return React.Children.map(_children, (child) => {
        if (child && ['function', 'object'].indexOf(typeof child) > -1) {
            const childrenProps = {
                labelCol: child.props?.labelCol ?? labelCol,
                labelAlign: child.props?.labelAlign ?? labelAlign,
                wrapperCol: child.props?.wrapperCol ?? wrapperCol,
                labelTextAlign: child.props?.labelTextAlign ?? labelTextAlign,
                isPreview: child.props?.isPreview ?? isPreview,
                colon: child.props?.colon ?? colon,
            };
            const { formItemProps = {}, ...componentProps } = child.props;
            const formItemColumn = formItemProps.columnSpan;
            const columnSpan = formItemColumn ?? 1;
            return createElement(ResponsiveGrid.Cell, { colSpan: columnSpan }, cloneElement(child, {
                formItemProps: Object.assign({}, pickDefined(childrenProps), formItemProps),
                ...componentProps,
                childFormChildren: _children,
                changingField,
                field,
            }));
        }
        return child;
    });
};
const pickDefined = (obj = {}) => {
    const newObj = {};
    Object.keys(obj).forEach((i) => {
        if (typeof obj[i] !== 'undefined') {
            newObj[i] = obj[i];
        }
    });
    return newObj;
};
